const forms = {
  onRequest: "Theo yêu cầu", // translated 
  person: "người", // translated 
  travelDate: "Ngày đi du lịch", // translated 
  travelDates: "Ngày khởi hành", // translated 
  cancel: "Hủy bỏ", // translated 
  getPrice: "Nhận báo giá", // translated 
};


export default forms;
